import type { FilterField } from '@vnetwork/ui/data';

/**
 * FilterBuilder field definitions for the cross-org resource inventories.
 * Pass via `defaultValue` NOT `value` (see ui-conventions). Provider + Org ID
 * are free-text; status is a per-resource select.
 */

export const opsInstanceFilterFields: FilterField[] = [
  { value: 'provider', label: 'Provider', input: 'text' },
  {
    value: 'status',
    label: 'Status',
    input: 'select',
    options: [
      { value: 'running', label: 'Running' },
      { value: 'stopped', label: 'Stopped' },
      { value: 'pending', label: 'Pending' },
      { value: 'error', label: 'Error' },
      { value: 'unknown', label: 'Unknown' },
    ],
  },
  { value: 'org_id', label: 'Org ID', input: 'text' },
];

export const opsDomainFilterFields: FilterField[] = [
  { value: 'provider', label: 'Provider', input: 'text' },
  {
    value: 'status',
    label: 'Status',
    input: 'select',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'pending', label: 'Pending' },
      { value: 'expired', label: 'Expired' },
      { value: 'terminated', label: 'Terminated' },
    ],
  },
  { value: 'org_id', label: 'Org ID', input: 'text' },
];
